"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorPage = exports.TopologicalEditorPageConfig = exports.CSS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var _1 = require(".");
var draw_button_1 = require("../../components/button/draw.button");
var carousel_1 = require("../../components/carousel");
var centeredMessage_1 = require("../../components/centeredMessage");
var icons_1 = require("../../components/icon/icons");
var sidebar_1 = require("../../components/sidebar");
var theme_1 = require("../../components/theme");
var tool_picker_1 = require("../../components/tool.picker");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var capture_preview_1 = require("../../modules/capture.preview/capture.preview");
var collection_view_1 = require("../../modules/collection.view/collection.view");
var map_mode_legend_1 = require("../../modules/map.mode.legend");
var topological_editor_collection_list_1 = require("../../modules/topological.editor.collection.list");
var topological_editor_toolbar_1 = require("../../modules/topological.editor.toolbar");
var services_1 = require("../../services");
var store_1 = require("../../store");
var page_1 = require("../page");
var mm_events_1 = require("./mm.events");
exports.CSS = {
    container: 'c-TopologicalEditor',
    content: 'c-TopologicalEditor__Content',
    divider: 'c-TopologicalEditor__Divider',
    toolpicker: 'c-TopolocalEditor__ToolPicker',
    smallContainer: 'c-TopologicalEditor__SmallContainer',
    overlaySave: 'c-TopologicalEditor__OverlaySave',
    toggleableElement: 'c-ToggleableElement'
};
var Style = (_a = {},
    _a[exports.CSS.container] = {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row'
    },
    _a[exports.CSS.content] = {
        width: '80%',
        borderLeft: "1px solid ".concat(theme_1.DefaultTheme.font.color.divider),
        position: 'relative'
    },
    _a[exports.CSS.divider] = {
        width: '100%',
        height: '1px',
        margin: '6px 0',
        background: theme_1.DefaultTheme.font.color.divider
    },
    _a[exports.CSS.toolpicker] = {
        position: 'absolute',
        top: '12px',
        right: '12px',
        zIndex: 100
    },
    _a[exports.CSS.smallContainer] = {
        flex: '1',
        overflow: 'hidden'
    },
    _a[exports.CSS.overlaySave] = {
        position: 'fixed',
        display: 'block',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': 'rgba(0,0,0,0.5)',
        'z-index': 200,
        cursor: 'pointer'
    },
    _a[exports.CSS.toggleableElement] = {
        minHeight: '0',
        flexGrow: '1'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.TopologicalEditorPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.topologicalEditor,
    path: ['/mapmode/:jobId', '/mapmode/:jobId/:collectionUUID'],
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.FEATURE_MAP_MODE],
        userLevelBlackList: [core_api_1.IkeUserRole.VIEWER, core_api_1.IkeUserRole.DOWNLOADER]
    },
    layout: { nav: false }
};
var TopologicalEditorPage = /** @class */ (function (_super) {
    tslib_1.__extends(TopologicalEditorPage, _super);
    function TopologicalEditorPage() {
        var _this = _super.call(this, exports.TopologicalEditorPageConfig) || this;
        _this.controller = new _1.TopologicalEditorController();
        _this.streeviewSidebar = new sidebar_1.Sidebar();
        _this.collectionSidebar = new sidebar_1.Sidebar();
        services_1.Services.Window.bindNavigateAway(i18n_1.T.DISCARD_CHANGES_CONFIRM, _this.checkExit);
        _this.events = new mm_events_1.MapModeInputEvents(_this);
        _this.events.init();
        return _this;
    }
    TopologicalEditorPage.prototype.checkExit = function () {
        return this.controller.hasChanges;
    };
    TopologicalEditorPage.prototype.onRemove = function () {
        this.controller.destroy();
        services_1.Services.Window.unbindNavigateAway(this.checkExit);
        services_1.Services.Map.map.getStreetView().setVisible(false);
        this.events.destroy();
    };
    Object.defineProperty(TopologicalEditorPage.prototype, "content", {
        get: function () {
            return (0, mithril_1.m)('div', {
                className: "".concat(exports.CSS.content, " ").concat(this.controller.contentClassNames)
            }, [
                this.controller.map.view(),
                tool_picker_1.ToolPicker.view({
                    children: this.tools,
                    className: exports.CSS.toolpicker
                })
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorPage.prototype, "carousel", {
        get: function () {
            var _this = this;
            var carousel = null;
            if (this.controller.selectedCollection) {
                var captures_1 = [];
                this.controller.selectedCollection.forEachField(function (field) {
                    if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                        var captureElements = field.getCaptures().map(function (capture) {
                            return capture_preview_1.CapturePreview.view(_this.controller.selectedCollection, capture, {
                                type: capture_preview_1.CapturePreviewType.MEDIUM,
                                truesize: false,
                                icon: true,
                                crosshair: false
                            });
                        });
                        captures_1 = captures_1.concat(captureElements);
                    }
                });
                if (captures_1.length) {
                    carousel = new carousel_1.Carousel({
                        slides: captures_1,
                        onSlideChange: function (index) { return _this.onSlideChange(index); }
                    });
                }
            }
            return carousel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorPage.prototype, "tools", {
        get: function () {
            var _this = this;
            var _a;
            return [
                this.controller.selectedCollection && (draw_button_1.DrawButton.view(icons_1.MaterialIcon.ADD, {
                    flip: false,
                    title: i18n_1.T.TOPO_TOOL_RELOCATE_POLE,
                    disabled: false,
                    selected: false,
                    solidBackground: true,
                    onclick: function () { return _this.controller.useTool('relocatePole'); }
                })),
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.VISIBILITY, {
                    flip: false,
                    title: i18n_1.T.TOPO_SHOW_HIDE_LABELS,
                    disabled: false,
                    selected: (_a = this.controller.map.overlay) === null || _a === void 0 ? void 0 : _a.viewCollectionLabels,
                    solidBackground: true,
                    onclick: function () { return _this.controller.map.overlay.toggleViewTitles(); }
                }),
                draw_button_1.DrawButton.view(icons_1.MaterialIcon.MAGIC_WAND, {
                    title: i18n_1.T.TOPO_TOOL_SNAP,
                    selected: false,
                    solidBackground: true,
                    onclick: function () { return _this.controller.bulkSnap(); }
                })
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorPage.prototype, "editCollectionForm", {
        get: function () {
            if (this.controller.selectedCollectionEdit) {
                var carouselOrEmpty = this.carousel;
                var carouselContainer = (0, mithril_1.m)('div', { className: exports.CSS.toggleableElement, style: { display: this.controller.selectedCollectionEdit.isCarouselShown ? 'block' : 'none' } }, carouselOrEmpty !== null ? this.carousel.view() : centeredMessage_1.CenteredMessage.view(i18n_1.T.NO_CAPTURES));
                return (0, mithril_1.m)('div', { className: exports.CSS.smallContainer }, new collection_view_1.CollectionEdit(this.controller.selectedCollectionEdit).view(carouselContainer));
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorPage.prototype, "jobName", {
        get: function () {
            return this.controller.tag ? this.controller.tag.name : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorPage.prototype, "titleBar", {
        get: function () {
            var _this = this;
            var titleBarParams = {
                title: this.jobName,
                selectedCollectionData: {
                    onClick: function (e) {
                        services_1.Services.Window.confirmPageChange(e, services_1.Services.Route.getRouteURL(page_1.IkePageName.collectionMeasure, tslib_1.__assign({ d: services_1.Services.Department.current.objectId, t: _this.controller.tag.objectId }, (_this.controller.selectedCollection) && { collection: _this.controller.selectedCollection.uuid })));
                    }
                },
                saveButton: {
                    disabled: !(this.controller.hasChanges || this.controller.isSaving),
                    onClick: function () { _this.controller.batchSave(); },
                    isSaving: this.controller.isSaving
                }
            };
            return titleBarParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorPage.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (services_1.Services.Department.current == null) {
                return null;
            }
            if (!services_1.Services.Streetview.isReady) {
                return null;
            }
            if (this.controller.routeCollectionUUID) {
                var collectionSummary_1 = store_1.AppStore.CollectionSummary.getFetchableByUuid(this.controller.routeCollectionUUID).value;
                if (collectionSummary_1) {
                    services_1.Services.Map.isReadyPromise.then(function () {
                        _this.controller.setSelectedCollectionRevision(collectionSummary_1.revision);
                    });
                }
            }
            return [
                (0, mithril_1.m)('div', {
                    className: exports.CSS.container
                }, [
                    this.collectionSidebar.view([
                        topological_editor_toolbar_1.TopologicalEditorToolbar.view(this.titleBar),
                        topological_editor_collection_list_1.TopologicalEditorCollectionList.view({
                            onItemClick: function (revision) {
                                _this.controller.setSelectedCollectionRevision(revision);
                                _this.controller.zoomToSelectedCollection();
                            },
                            collections: this.controller.collections,
                            selectedRevision: this.controller.selectedCollectionRevision,
                            collectionsEditController: this.controller
                        }),
                        (0, mithril_1.m)('div', { className: exports.CSS.divider }),
                        map_mode_legend_1.MapModeLegend.view()
                    ]),
                    this.content,
                    this.controller.selectedCollectionRevision && this.streeviewSidebar.view([
                        this.editCollectionForm,
                        (0, mithril_1.m)('div', { className: exports.CSS.divider }),
                        (0, mithril_1.m)('div', { className: exports.CSS.smallContainer }, this.controller.streetview.view())
                    ])
                ]),
                this.controller.isSaving ? (0, mithril_1.m)('div', { className: exports.CSS.overlaySave }) : null
            ];
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorPage.prototype.onBeforeUnload = function () {
        this.controller.collectionEditControllers.forEach(function (controller) {
            controller.discardAndDestroyEdit();
        });
    };
    TopologicalEditorPage.prototype.onSlideChange = function (index) {
        var captureIds = this.controller.getCaptureIds();
        var captureId = captureIds[index];
        if (captureId) {
            this.controller.setSelectedCaptureId(captureId);
        }
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorPage.prototype, "checkExit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorPage.prototype, "carousel", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorPage.prototype, "jobName", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorPage.prototype, "onSlideChange", null);
    return TopologicalEditorPage;
}(page_1.IkePage));
exports.TopologicalEditorPage = TopologicalEditorPage;
//# sourceMappingURL=topological.editor.page.js.map